import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const renderMarkdown = (text, options = {}) => {
  if (typeof text === "string") {
    const components = {
      ...(!options?.paragraphs && { p: React.Fragment }),
      del: ({ children }) => <del aria-label="Deleted">{children}</del>,
    };

    if (options?.externalLinks) {
      components.a = ({ href, children }) => (
        <a href={href} rel="noopener noreferrer" target="_blank">
          {children}
        </a>
      );
    }

    return (
      <ReactMarkdown components={components} remarkPlugins={[remarkGfm]}>
        {text.replaceAll("'", "'")}
      </ReactMarkdown>
    );
  }

  return text;
};
